module.exports = __webpack_public_path__ + "img/image31.4ca6fef0.jpg";